module.exports = __webpack_public_path__ + "static/img/icon-download.059d86db.svg";